let baseComponentConfigs = [
    {
        "cId": "settingsEditor2",
        "cTitle": "DevDash Settings Editor",
        "cType": "settingsEditor",
        "cConfig": {
            "staticPosition": true
        }
    },
    {
        "cId": "settingsEditor",
        "cTitle": "DevDash Settings Editor",
        "cType": "settingsEditor",
        "cConfig": {
            "staticPosition": false
        }
    },
    {
        "cId": "tabList_cmpdetails",
        "cTitle": "Component Details Tab List",
        "cType": "tabList",
        "cConfig": {
            "hideIndicator": false,
            "tabs": [
                {
                    "title": "Settings",
                    "components": [
                        {
                            "cId": "settingsEditor2",
                            "cType": "settingsEditor"
                        }
                    ],
                    "editorEnabled": true
                },
                {
                    "title": "Statistics",
                    "components": [
                        {
                            "cId": "componentStatistic",
                            "cType": "componentStatistic"
                        }
                    ],
                    "editorEnabled": false
                },
                {
                    "title": "Test Data",
                    "components": [
                        {
                            "cId": "componentTestData",
                            "cType": "componentTestData"
                        }
                    ],
                    "editorEnabled": false
                }
            ]
        }
    },
    {
        "cId": "tabList_customServiceDetails",
        "cTitle": "Custom Service Details Tab List",
        "cType": "tabList",
        "cConfig": {
            "hideIndicator": false,
            "tabs": [
                {
                    "title": "Settings",
                    "components": [
                        {
                            "cId": "customServiceEditor",
                            "cType": "customServiceEditor"
                        }
                    ],
                    "editorEnabled": false
                },
                {
                    "title": "Statistics",
                    "components": [
                        {
                            "cId": "customServiceStatistic",
                            "cType": "customServiceStatistic"
                        }
                    ],
                    "editorEnabled": false
                },
                {
                    "title": "History",
                    "components": [
                        {
                            "cId": "customServiceHistory",
                            "cType": "customServiceHistory"
                        }
                    ],
                    "editorEnabled": false
                },
                {
                    "title": "Errors",
                    "components": [
                        {
                            "cId": "customServiceErrors",
                            "cType": "customServiceErrors"
                        }
                    ],
                    "editorEnabled": false
                }
            ]
        }
    },
    {
        "cId": "actionParamWizard",
        "cType": "actionParamWizard",
        "cTitle": "Action Param Wizard",
        "cConfig": {
            "lockedConfig": true
        }
    },
    {
        "cId": "import",
        "cType": "import",
        "cTitle": "Import Tool",
        "hideFromDevDash": true,
        "cConfig": {
            "lockedConfig": true,
            "tabListComponentId": "tabList_importTool",
            "messageEmptyImportsComponentId": "messagePanel_import_no_imports",
            "gridFieldMappingComponentId": "grid_import_field_mapping",
            "gridPastImportsComponentId": "grid_import_past_imports",
            "gridImportDetailsComponentId": "grid_import_import_details"
        }
    },
    {
        "cId": "import_importTool",
        "cType": "import",
        "cTitle": "Import Tool",
        "hideFromDevDash": true,
        "cConfig": {
            "lockedConfig": true,
            "tabListComponentId": "tabList_importTool",
            "messageEmptyImportsComponentId": "messagePanel_import_no_imports",
            "gridFieldMappingComponentId": "grid_import_field_mapping",
            "gridPastImportsComponentId": "grid_import_past_imports",
            "gridImportDetailsComponentId": "grid_import_import_details"
        }
    },
    {
        "cId": "messagePanel_import_no_imports",
        "cType": "messagePanel",
        "cTitle": "Import: no imports were found",
        "cConfig": {
            "cDescription": "",
            "headingTemplate": "",
            "allowDismiss": false,
            "messageFields": [],
            "mergeFields": [],
            "backdropType": "white void",
            "lockedConfig": true,
            "messagePanelMargin": "30px 0px 20px 0px",
            "customMessageTemplate": "<div class=\"no-imports\">The are no imports yet, please click \"Start new import\" button.</div>",
            "customMessagePanelMargin": "",
            "dismissStyle": "closeicon",
            "componentBackgroundColor": "#ffffffff",
            "componentBoxShadow": "0 0 15px rgba(0,0,0, 0.15)",
            "componentBorderRadius": "1",
            "backgroundColor": "#f3f7f9",
            "borderColor": "#92a3b6",
            "textColor": "#000000ff"
        }
    },
    {
        "cId": "grid_import_field_mapping",
        "cTitle": "Import: Field Mapping Grid",
        "cType": "grid",
        "hideFromDevDash": true,
        "cConfig": {
            "lockedConfig": true,
            "ref": "grid_import_field_mapping",
            "customControls": [
                {
                    "name": "GRID_FIELD",
                    "type": "boolean"
                }
            ],
            "tableHeaders": [
                {
                    "field": "columnNumber",
                    "text": "Column #",
                    "width": "120",
                    "minWidth": "120",
                    "maxWidth": "120"
                },
                {
                    "field": "columnTitle",
                    "text": "Column Title"
                },
                {
                    "field": "matched",
                    "text": "Matched",
                    "width": "150",
                    "minWidth": "150",
                    "maxWidth": "150",
                    "columnTemplate": "<div><div v-if='data.matched'><span class='e-icons found'></span></div><div v-else><span class='e-icons not-found'>!</span></div></div>"
                },
                {
                    "field": "uniqueIdentifier",
                    "text": "Unique Identifier",
                    "width": "150",
                    "minWidth": "150",
                    "maxWidth": "150",
                    "columnTemplate": "<div v-if='data.uniqueIdentifier'><control :name='\"GRID_FIELD__\" + data.columnID' :value='data.checked || false'></control></div>"
                }
            ],
            "pageSettings": {
                "pageSize": 10,
                "pageCount": 5
            },
            "gridSettings": {
                "paging": false,
                "sorting": true,
                "filtering": false,
                "grouping": false,
                "height": "100%",
                "clipMode": "EllipsisWithTooltip"
            }
        }
    },
    {
        "cId": "grid_import_past_imports",
        "cTitle": "Import: Past Imports Grid",
        "cType": "grid",
        "hideFromDevDash": true,
        "cConfig": {
            "lockedConfig": true,
            "customControls": [
                {
                    "name": "SHOW_IMPORT_DETAILS",
                    "type": "button",
                    "cssClass": "e-link",
                    "hideTitle": true
                }
            ],
            "tableHeaders": [
                {
                    "field": "name",
                    "text": "Past Imports",
                    "minWidth": "250"
                },
                {
                    "field": "totalRecords",
                    "text": "Total",
                    "width": "90",
                    "minWidth": "90",
                    "columnTemplate": "<div><div v-if='data.totalRecords'><control :name='\"SHOW_IMPORT_DETAILS__totalRecords__\" + data.index' :importID='data.importID' :label='data.totalRecords' :importStatus='0'></control></div><div v-else class='no-found-count'>-</div></div>"
                },
                {
                    "field": "newRecords",
                    "text": "New",
                    "width": "90",
                    "minWidth": "90",
                    "columnTemplate": "<div><div v-if='data.newRecords'><control :name='\"SHOW_IMPORT_DETAILS__newRecords__\" + data.index' :importID='data.importID' :label='data.newRecords' :importStatus='1'></control></div><div v-else class='no-found-count'>-</div></div>"
                },
                {
                    "field": "updatedRecords",
                    "text": "Updated",
                    "width": "110",
                    "minWidth": "110",
                    "columnTemplate": "<div><div v-if='data.updatedRecords'><control :name='\"SHOW_IMPORT_DETAILS__updatedRecords__\" + data.index' :importID='data.importID' :label='data.updatedRecords' :importStatus='2'></control></div><div v-else class='no-found-count'>-</div></div>"
                },
                {
                    "field": "errorCount",
                    "text": "Error",
                    "width": "90",
                    "minWidth": "90",
                    "columnTemplate": "<div><div v-if='data.errorCount'><control :name='\"SHOW_IMPORT_DETAILS__errorCount__\" + data.index' :importID='data.importID' :label='data.errorCount' :importStatus='-1'></control></div><div v-else class='no-found-count'>-</div></div>"
                },
                {
                    "field": "user",
                    "text": "User",
                    "width": "200",
                    "minWidth": "170",
                    "columnTemplate": "<div v-if='data.user'>{{data.user.name}}<br/>{{data.user.email}}</div>"
                },
                {
                    "field": "started",
                    "text": "Started",
                    "width": "140",
                    "minWidth": "140",
                    "type": "date",
                    "format": { "type": "date", "format": "dd MMM yyyy HH:mm" }
                },
                {
                    "field": "finished",
                    "text": "Finished",
                    "width": "140",
                    "minWidth": "140",
                    "type": "date",
                    "format": { "type": "date", "format": "dd MMM yyyy HH:mm" }
                }
            ],
            "pageSettings": {
                "pageSize": 15,
                "pageCount": 5
            },
            "gridSettings": {
                "paging": true,
                "sorting": true,
                "filtering": false,
                "grouping": false,
                "clipMode": "EllipsisWithTooltip"
            }
        }
    },
    {
        "cId": "grid_mainGrid",
        "cTitle": "VMS: Main Grid",
        "cType": "grid",
        "hideFromDevDash": true,
        "cConfig": {
            "lockedConfig": true,
            "pageSettings": {
                "pageSize": 100,
                "pageCount": 5
            },
            "gridSettings": {
                "paging": true,
                "sorting": true,
                "rowHeight": 28,
                "calculateWidth": true,
                "filtering": true,
                "grouping": false,
                "resizing": true,
                "reordering": true,
                "minHeight": '230',
                "enableCheckBox": true,
                "clipMode": "EllipsisWithTooltip",
                "heightToContent": true,
                "isMainGrid": true
            }
        }
    },
    {
        "cId": "gridMain_mainGrid",
        "cTitle": "VMS: Main Grid",
        "cType": "gridMain",
        "hideFromDevDash": true,
        "cConfig": {
            "lockedConfig": true,
            "pageSettings": {
                "pageSize": 100,
                "pageCount": 5
            },
            "gridSettings": {
                "paging": true,
                "sorting": true,
                "rowHeight": 28,
                "calculateWidth": true,
                "filtering": true,
                "grouping": true,
                "resizing": true,
                "reordering": true,
                "minHeight": '230',
                "enableCheckBox": true,
                "clipMode": "EllipsisWithTooltip",
                "heightToContent": true,
                "isMainGrid": true
            }
        }
    },
    {
        "cId": "menuBar_mainGrid",
        "cTitle": "VMS: Menu Bar",
        "cType": "menuBar",
        "hideFromDevDash": true,
        "cConfig": {
            "lockedConfig": true,
            "menuBarSettings": {
                "isMainGrid": true,
                "isFixedToTop": true
            }
        }
    },
    {
        "cId": "foldersManager_mainGrid",
        "cTitle": "VMS: Folder Manager",
        "cType": "foldersManager",
        "hideFromDevDash": true,
        "cConfig": {
            "lockedConfig": true,
            "foldersManagerSettings": {
                "isMainGrid": true
            }
        }
    },
    {
        "cId": "grid_import_import_details",
        "cTitle": "Import: Import Details Grid",
        "cType": "grid",
        "hideFromDevDash": true,
        "cConfig": {
            "lockedConfig": true,
            "tableHeaders": [
                {
                    "field": "rowNum",
                    "text": "Row number in file",
                    "width": "140",
                    "minWidth": "140"
                },
                {
                    "field": "recordID",
                    "text": "Record ID",
                    "width": "100",
                    "minWidth": "100"
                },
                {
                    "field": "status",
                    "text": "Status",
                    "width": "100",
                    "minWidth": "100"
                },
                {
                    "field": "errors",
                    "text": "Errors"
                }
            ],
            "pageSettings": {
                "pageSize": 15,
                "pageCount": 5
            },
            "gridSettings": {
                "paging": true,
                "sorting": true,
                "filtering": false,
                "grouping": false,
                "toolbar": ["ExcelExport"],
                "allowExcelExport": true,
                "exportFileName": "Import Details",
                "clipMode": "EllipsisWithTooltip"
            }
        }
    },
    {
        "cId": "grid_add_hours_non_placed",
        "cTitle": "Add Hours: Non Placed Volunteers",
        "cType": "grid",
        "hideFromDevDash": true,
        "cConfig": {
            "lockedConfig": true,
            "isPropGrid": true,
            "pageSettings": {
                "pageSize": 15,
                "pageCount": 5
            },
            "gridSettings": {
                "paging": true,
                "sorting": true,
                "filtering": false,
                "grouping": false,
                "toolbar": ["ExcelExport"],
                "allowExcelExport": true,
                "exportFileName": "Non Placed Volunteers",
                "clipMode": "EllipsisWithTooltip"
            }
        }
    },
    {
        "cId": "tabList_importTool",
        "cTitle": "Import/Export tool",
        "cType": "tabList",
        "hideFromDevDash": true,
        "cConfig": {
            "hideIndicator": true,
            "isWizard": true,
            "showFooterWhen": [
                {
                    "record": "self",
                    "criteriaRecord": "self",
                    "recordId": "",
                    "prop": "showFooter",
                    "valueType": "criteria",
                    "value": "",
                    "valuePath": "",
                    "valueControl": "",
                    "criteria": {
                        "condition": "and",
                        "rules": [
                            {
                                "label": "Data: selectedTabIndex",
                                "field": "selectedTabIndex",
                                "operator": "notequal",
                                "type": "number",
                                "value": 0
                            }
                        ]
                    }
                }
            ],
            "customControls": [
                {
                    "name": "IMPORT_UPLOAD",
                    "ref": "IMPORT_UPLOAD",
                    "type": "upload",
                    "allowedExtensions": ".csv, .xlsx, .xls, .txt",
                    "allowedExtensionsText": ".csv, .xlsx, .xls, .txt (tab delimited)",
                    "showAsDefaultInput": false,
                    "entityName": "Records",
                    "multiple": false,
                    "showRemoveConfirmation": false,
                    "showExtensionsText": true
                },
                {
                    "name": "IMPORT_GUIDE",
                    "type": "button",
                    "label": "View import guide",
                    "cssClass": "e-link"
                },
                {
                    "name": "IMPORT_SAMPLE",
                    "type": "button",
                    "label": "Download sample spreadsheet",
                    "cssClass": "e-link"
                },
                {
                    "name": "IMPORT_VALIDATE_ONLY",
                    "type": "checkbox",
                    "label": "Run a Test"
                },
                {
                    "name": "IMPORT_CREATE_GRID",
                    "type": "checkbox",
                    "label": "Save a Grid"
                },
                {
                    "name": "IMPORT_FAQ",
                    "type": "button",
                    "label": "View the FAQ",
                    "cssClass": "e-link"
                },
                {
                    "name": "IMPORT_FILE_NAME",
                    "type": "string",
                    "asField": true
                },
                {
                    "name": "IMPORT_FILE_RECORDS",
                    "type": "string",
                    "asField": true
                },
                {
                    "name": "IMPORT_FIELDS_LIST",
                    "type": "list"
                },
                {
                    "name": "IMPORT_RESULTS_LIST",
                    "type": "list"
                },
                {
                    "name": "IMPORT_FILE_TYPE",
                    "type": "RADIO_BUTTON_LIST",
                    "items": [],
                    "default": 1
                },
                {
                    "name": "IMPORT_UPLOAD_BEHAVIOUR",
                    "label": "IMPORT",
                    "type": "RADIO_BUTTON_LIST",
                    "items": [
                        { "label": "Add/Update all", "value": 0 },
                        { "label": "Add new records only", "value": 1 },
                        { "label": "Update existing only", "value": 2 }
                    ],
                    "default": 0
                },
                {
                    "name": "IMPORT_UPDATE_BEHAVIOUR",
                    "label": "UPDATE",
                    "type": "RADIO_BUTTON_LIST",
                    "items": [
                        { "label": "Overwrite existing field values", "value": 0 },
                        { "label": "Update only empty fields", "value": 1 }
                    ],
                    "default": 0,
                    "logic": [
                        {
                            "record": "self",
                            "prop": "display",
                            "valueType": "criteria",
                            "criteria": "this.controls.IMPORT_UPLOAD_BEHAVIOUR.value !== 1"
                        }
                    ]
                },
                {
                    "name": "IMPORT_PROGRESS",
                    "type": "progress",
                    "pType": "Circular",
                    "showValueLabel": true,
                    "height": "267px",
                    "ref": "IMPORT_PROGRESS",
                    "trackThickness": 12,
                    "progressThickness": 12,
                    "value": 0,
                    "animation": {
                        "enable": true,
                        "duration": 0,
                        "delay": 0
                    }
                },
                {
                    "name": "IMPORT_CANCEL",
                    "type": "button",
                    "label": "Cancel"
                },
                {
                    "name": "IMPORT_LOG",
                    "type": "text",
                    "label": "Import log",
                    "readonly": true,
                    "rows": 10
                },
                {
                    "name": "IMPORT_COMPLETED",
                    "type": "string",
                    "label": "Your import is complete.",
                    "display": false,
                    "asField": true
                }
            ],
            "tabs": [
                {
                    "title": "Upload",
                    "color": {
                        "backgroundColor": "#f3f7f9",
                        "textColor": "black",
                        "borderColor": "transparent"
                    },
                    "showIcon": true,
                    "iconCss": "bubble",
                    "iconPosition": "Top",
                    "customTemplate": `
                        <div id='importUploadTab'>
                            <br/><br/>
                            <div class='title'>Select Record Type to Import</div>
                            <div class='importFileTypeRadio'>
                                <control name='IMPORT_FILE_TYPE'></control>
                            </div>
                            <div class='title'>Select File to Import</div>
                            <div class='uploader'>
                                <control name='IMPORT_UPLOAD'></control>
                            </div>
                            <br/><br/>
                            <div class='help-links'>
                                <div class='help-links-title'>Need help getting started?</div>
                                <div class='help-links-controls'>
                                    <control name='IMPORT_GUIDE'></control>
                                    <div class='line-break'>|</div>
                                    <control name='IMPORT_SAMPLE'></control>
                                    <div class='line-break'>|</div>
                                    <control name='IMPORT_FAQ'></control>
                                </div>
                            </div>
                        </div>
                    `
                },
                {
                    "title": "Map",
                    "color": {
                        "backgroundColor": "#f3f7f9",
                        "textColor": "black",
                        "borderColor": "transparent"
                    },
                    "showIcon": true,
                    "iconCss": "bubble",
                    "iconPosition": "Top",
                    "customTemplate": `
                        <div id='importMapTab'>
                            <div class='fields-list'>
                                <div class='title'>Please confirm columns mapping below, and choose at least one Unique Identifier column:</div>
                                <grid cId='grid_import_field_mapping' :prop-data='controls["IMPORT_FIELDS_LIST"].items'></grid>
                            </div>
                            <div class='title'>
                                <control name='IMPORT_FILE_NAME'></control>
                                <control name='IMPORT_FILE_RECORDS'></control>
                            </div>
                            <div class='mapping-controls'>
                                <control name='IMPORT_UPLOAD_BEHAVIOUR'></control>
                                <div class='add-controls update-behaviour'>
                                    <control name='IMPORT_UPDATE_BEHAVIOUR'></control>
                                    <div class='warning-label'>
                                        <span>* To clear out values via Import,<br>please enter NULL in the cells.</span>
                                    </div>
                                </div>
                                <div class='add-controls'>
                                    <div class='title'>VIEW</div>
                                    <control name='IMPORT_VALIDATE_ONLY'></control>
                                    <br/>
                                    <control name='IMPORT_CREATE_GRID'></control>
                                </div>
                            </div>
                        </div>
                    `
                },
                {
                    "title": "Progress",
                    "color": {
                        "backgroundColor": "#f3f7f9",
                        "textColor": "black",
                        "borderColor": "transparent"
                    },
                    "showIcon": true,
                    "iconCss": "bubble",
                    "iconPosition": "Top",
                    "customTemplate": `
                        <div id='importProgressTab'>
                            <div class='progressIndicator'>
                                <control name='IMPORT_PROGRESS'></control>
                            </div>
                            <div class='log'>
                                <control name='IMPORT_LOG'></control>
                                <control name='IMPORT_CANCEL'></control>
                                <control name='IMPORT_COMPLETED'></control>
                            </div>
                            <div class='clearfix'></div>
                        </div>
                    `
                },
                {
                    "title": "Confirmation",
                    "color": {
                        "backgroundColor": "#f3f7f9",
                        "textColor": "black",
                        "borderColor": "transparent"
                    },
                    "showIcon": true,
                    "iconCss": "bubble",
                    "iconPosition": "Top",
                    "customTemplate": `
                        <div id='importConfirmationTab'>
                            <div class='title'>Import results</div>
                            <grid cId="grid_import_import_details" :prop-data='controls["IMPORT_RESULTS_LIST"].items'></grid>
                        </div>
                    `
                }
            ],
            "showFooter": true,
            "footerCustomTemplate": "",
            "footerColor": {
                "backgroundColor": "#f3f7f9",
                "textColor": "white",
                "borderColor": "none"
            },
            "buttons": [
                {
                    "id": "back",
                    "name": "back",
                    "label": "Back",
                    "type": "button",
                    "color": {
                        "backgroundColor": "white",
                        "textColor": "#ff6d53",
                        "borderColor": "#ff6d53"
                    },
                    "cssClass": "e-flat",
                    "showIcon": true,
                    "iconCss": "e-icons e-arrow-left",
                    "iconPosition": "Left",
                    "onclick": "back"
                },
                {
                    "id": "cancel",
                    "name": "cancel",
                    "label": "Close",
                    "type": "button",
                    "cssClass": "e-link",
                    "color": {
                        "backgroundColor": "transparent",
                        "textColor": "black",
                        "borderColor": "transparent"
                    },
                    "onclick": "cancel"
                },
                {
                    "id": "next",
                    "name": "next",
                    "type": "button",
                    "label": "Next",
                    "color": {
                        "backgroundColor": "#ff6d53",
                        "textColor": "white"
                    },
                    "cssClass": "e-flat",
                    "showIcon": true,
                    "iconCss": "e-icons e-arrow-right",
                    "iconPosition": "Right",
                    "onclick": "next"
                },
                {
                    "id": "finish",
                    "name": "finish",
                    "type": "button",
                    "label": "Finish",
                    "color": {
                        "backgroundColor": "#ff6d53",
                        "textColor": "white"
                    },
                    "cssClass": "e-flat",
                    "onclick": "finish"
                }
            ]
        }
    },
    {
        "cId": "tabList_wizard",
        "cTitle": "Component Details Tab List",
        "cType": "tabList",
        "hideFromDevDash": true,
        "cConfig": {
            "hideIndicator": true,
            "isWizard": true,
            "tabs": [
                {
                    "title": "First",
                    "color": {
                        "backgroundColor": "#f3f7f9",
                        "textColor": "black",
                        "borderColor": "transparent"
                    },
                    "showIcon": true,
                    "iconCss": "bubble",
                    "iconPosition": "Top",
                    "customTemplate": "<div>123</div>",
                    "components": [
                        {
                            "cId": "componentStatistic",
                            "cType": "componentStatistic"
                        }
                    ]
                },
                {
                    "title": "Second",
                    "color": {
                        "backgroundColor": "transparent",
                        "textColor": "black",
                        "borderColor": "transparent"
                    },
                    "showIcon": true,
                    "iconCss": "bubble",
                    "iconPosition": "Left",
                    "components": [
                        {
                            "cId": "buildInfo",
                            "cType": "buildInfo"
                        }
                    ]
                },
                {
                    "title": "Show when you on the second",
                    "color": {
                        "backgroundColor": "transparent",
                        "textColor": "black",
                        "borderColor": "transparent"
                    },
                    "showIcon": true,
                    "iconCss": "bubble",
                    "iconPosition": "Left",
                    "customTemplate": "Show when",
                    "components": [
                        {
                            "cId": "buildInfo",
                            "cType": "buildInfo"
                        }
                    ],
                    "showWhen": [
                        {
                            "record": "object0.",
                            "criteriaRecord": "component",
                            "recordId": "",
                            "prop": "show",
                            "valueType": "criteria",
                            "value": "",
                            "valuePath": "",
                            "valueControl": "",
                            "criteria": {
                                "condition": "or",
                                "rules": [
                                    {
                                        "label": "Data: selectedTabIndex",
                                        "field": "selectedTabIndex",
                                        "operator": "equal",
                                        "type": "number",
                                        "value": 1
                                    },
                                    {
                                        "label": "Data: selectedTabIndex",
                                        "field": "selectedTabIndex",
                                        "operator": "equal",
                                        "type": "number",
                                        "value": 2
                                    }
                                ]
                            }
                        }
                    ],
                    "completeWhen": [
                        {
                            "record": "object0.",
                            "criteriaRecord": "component",
                            "recordId": "",
                            "prop": "complete",
                            "valueType": "criteria",
                            "value": "",
                            "valuePath": "",
                            "valueControl": "",
                            "criteria": {
                                "condition": "or",
                                "rules": [
                                    {
                                        "label": "Data: selectedTabIndex",
                                        "field": "selectedTabIndex",
                                        "operator": "equal",
                                        "type": "number",
                                        "value": 1
                                    },
                                    {
                                        "label": "Data: selectedTabIndex",
                                        "field": "selectedTabIndex",
                                        "operator": "equal",
                                        "type": "number",
                                        "value": 2
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    "title": "Fourth",
                    "color": {
                        "backgroundColor": "transparent",
                        "textColor": "black",
                        "borderColor": "transparent"
                    },
                    "showIcon": true,
                    "iconCss": "bubble",
                    "iconPosition": "Left",
                    "customTemplate": "asd",
                    "components": [
                        {
                            "cId": "buildInfo",
                            "cType": "buildInfo"
                        }
                    ]
                }
            ],
            "showFooter": true,
            "footerCustomTemplate": "",
            "footerColor": {
                "backgroundColor": "#f3f7f9",
                "textColor": "white",
                "borderColor": "none"
            },
            "buttons": [
                {
                    "id": "back",
                    "name": "back",
                    "label": "Back",
                    "type": "button",
                    "color": {
                        "backgroundColor": "white",
                        "textColor": "#ff6d53",
                        "borderColor": "#ff6d53"
                    },
                    "cssClass": "e-flat",
                    "showIcon": true,
                    "iconCss": "e-icons e-arrow-left",
                    "iconPosition": "Left",
                    "onclick": "back"
                },
                {
                    "id": "next",
                    "name": "next",
                    "type": "button",
                    "label": "Next",
                    "color": {
                        "backgroundColor": "#ff6d53",
                        "textColor": "white"
                    },
                    "cssClass": "e-flat",
                    "showIcon": true,
                    "iconCss": "e-icons e-arrow-right",
                    "iconPosition": "Right",
                    "onclick": "next"
                }
            ]
        }
    },
    {
        "cId": "chart_statistic",
        "cTitle": "Statistic Chart",
        "cType": "chart",
        "cConfig": {
            "cId": "chart_statistic",
            "cTitle": "Statistic Chart",
            "cType": "chart",
            "primaryXAxis": {
                "valueType": "Category",
                "labelPlacement": "OnTicks"
            },
            "columnWidth": "0.98",
            "width": "100%",
            "type": "Column",
            "cDescription": "",
            "chartWidth": "100%",
            "chartTitle": "Usage statistics",
            "countSeries": [
                {
                    "seriesTitle": "Usage statistics"
                }
            ],
            "hideChartTitle": "1"
        }
    },
    {
        "cId": "grid_info",
        "cTitle": "Grid",
        "cType": "grid",
        "cConfig": {
            "tableHeaders": [
                {
                    "field": "cTitle",
                    "text": "Name",
                    "width": "150"
                },
                {
                    "field": "searchValue",
                    "text": "Column Search",
                    "width": "150"
                },
                {
                    "field": "sortDir",
                    "text": "Sort Direction",
                    "width": "150"
                },
                {
                    "field": "sortPos",
                    "text": "Sort Order",
                    "width": "100"
                },
                {
                    "field": "width",
                    "text": "Width",
                    "width": "100"
                }
            ],
            "gridSettings": {
                "paging": false,
                "sorting": true,
                "filtering": false,
                "grouping": false
            }
        }
    },
    {
        "cId": "grid_settings",
        "cTitle": "Grid",
        "cType": "grid",
        "cConfig": {
            "tableHeaders": [
                {
                    "field": "Name",
                    "text": "Name",
                    "width": "150"
                },
                {
                    "field": "Value",
                    "text": "Value",
                    "width": "150"
                }
            ],
            "gridSettings": {
                "paging": false,
                "sorting": false,
                "filtering": false,
                "grouping": false
            }
        }
    },
    {
        "cId": "grid_statistics",
        "cTitle": "Grid",
        "cType": "grid",
        "cConfig": {
            "tableHeaders": [
                {
                    "field": "last_load",
                    "text": "Last Used",
                    "width": "120",
                    "type": "date",
                    "format": { "type": "date", "format": "dd MMM yyyy" }
                },
                {
                    "field": "instance",
                    "text": "Instance",
                    "width": "150"
                },
                {
                    "field": "projectName",
                    "text": "Project Name",
                    "width": "130"
                },
                {
                    "field": "accountId",
                    "text": "Account ID",
                    "width": "120"
                },
                {
                    "field": "recruiterId",
                    "text": "Recruiter ID",
                    "width": "170"
                },
                {
                    "field": "count_loads",
                    "text": "Executions",
                    "width": "150"
                }
            ],
            "gridSettings": {
                "paging": false,
                "sorting": true,
                "filtering": false,
                "grouping": false
            }
        }
    },
    {
        "cId": "grid_cmpstatistic",
        "cTitle": "Grid",
        "cType": "grid",
        "cConfig": {
            "tableHeaders": [
                {
                    "field": "last_load",
                    "text": "Last Used",
                    "width": "120",
                    "type": "date",
                    "format": { "type": "date", "format": "dd MMM yyyy" }
                },
                {
                    "field": "instance",
                    "text": "Instance",
                    "width": "150"
                },
                {
                    "field": "projectName",
                    "text": "Project Name",
                    "width": "130"
                },
                {
                    "field": "accountId",
                    "text": "Account ID",
                    "width": "120"
                },
                {
                    "field": "recruiterId",
                    "text": "Recruiter ID",
                    "width": "170"
                },
                {
                    "field": "count_loads",
                    "text": "Executions",
                    "width": "150"
                }
            ],
            "pageSettings": {
                "pageSize": 10,
                "pageCount": 5
            },
            "gridSettings": {
                "paging": true,
                "sorting": true,
                "filtering": false,
                "grouping": false
            }
        }
    },
    {
        "cId": "signInOut",
        "cTitle": "Sign In/Out",
        "cType": "signInOut",
        "hideFromDevDash": true,
        "cConfig": {}
    },
    {
        "cId": "layoutContainer",
        "cType": "layoutContainer",
        "cTitle": "Static Layout Container",
        "cConfig": {
            "msg": "A Test From Local.",
            "lockedConfig": true,
            "settings": {
                "header": "A Layout"
            },
            "components": [
            ],
            "positions": [
                [],
                [],
                []
            ],
            "templateFile": "staticTemplates/2_column_with_resize.js",
            "storeProps": [],
            "displayIf": [],
            "layoutDatamap": []
        }
    },
    {
        "layoutId": "layoutSignin",
        "msg": "A Test From Local.",
        "hideFromDevDash": true,
        "components": [
            { "cId": "signinLogin", "cType": "signinLogin" },
            { "cId": "signInOut", "cType": "signInOut" }
        ],
        "positions": [
            {
                "label": "Header",
                "posIndex": 1,
                "components": []
            },
            {
                "label": "Main Column",
                "posIndex": 0,
                "components": [
                    { "cType": "signinLogin", "cId": "signinLogin", "position": 1 },
                    { "cType": "signInOut", "cId": "signInOut", "position": 1 }
                ]
            },
            {
                "label": "Footer",
                "posIndex": 2,
                "components": []
            }
        ],
        "displayIf": [
            {
                "record": "component",
                "criteriaRecord": "self",
                "recordId": "",
                "prop": "displayedComponents.signInOut",
                "valueType": "criteria",
                "value": "",
                "valuePath": "",
                "valueControl": "",
                "criteria": {
                    "condition": "and",
                    "rules": [
                        {
                            "label": "Store Props: volunteerLoggedIn",
                            "field": "volunteerLoggedIn",
                            "operator": "equal",
                            "type": "boolean",
                            "value": true
                        }
                    ]
                }
            },
            {
                "record": "component",
                "criteriaRecord": "self",
                "recordId": "",
                "prop": "displayedComponents.signinLogin",
                "valueType": "criteria",
                "value": "",
                "valuePath": "",
                "valueControl": "",
                "criteria": {
                    "condition": "and",
                    "rules": [
                        {
                            "label": "Store Props: volunteerLoggedIn",
                            "field": "volunteerLoggedIn",
                            "operator": "equal",
                            "type": "boolean",
                            "value": false
                        }
                    ]
                }
            }
        ],
        "showIf": [
            {
                "record": "component",
                "prop": "showedComponents.signinLogin",
                "valueType": "criteria",
                "criteria": "this.volunteerLoggedIn == false"
            }
        ],
        "description": "The main layout for SignIn.",
        "settings": {
            "enableHeader": false,
            "header": "",
            "headerBgColor": "#ccccccff",
            "textColor": "#000000ff",
            "enableFooter": false,
            "columnRatio": "1:1",
            "layoutWidthType": "fluid",
            "bodyBgColor": "#ffffffff",
            "showComponentBorders": false
        },
        "storeProps": [
            {
                "property": "volunteerLoggedIn",
                "default": false,
                "type": "boolean",
                "key": "2"
            }
        ],
        "templateFile": "staticTemplates/1_column.js",
        "layoutDatamap": [
            {
                "property": "stationId",
                "from": "thisStore",
                "to": "signInOut",
                "as": "stationId"
            },
            {
                "property": "volunteer",
                "from": "thisStore",
                "to": "signInOut",
                "as": "volunteer"
            },
            {
                "property": "stationSettings",
                "from": "thisStore",
                "to": "signInOut",
                "as": "stationSettings"
            },
            {
                "property": "volunteerLoggedIn",
                "from": "thisStore",
                "to": "signinLogin",
                "as": "volunteerLoggedIn"
            }
        ],
        "cType": "layoutContainer",
        "lockedConfig": true,
        "cId": "layoutSignin",
        "cTitle": "Static Layout Container",
        "cDescription": "",
        "controls": [],
        "modifiedInstances": "dev",
        "isGlobal": true
    },
    {
        "cId": "contactCard1",
        "cType": "contactCard",
        "cTitle": "Contact Card"
    },
    {
        "cId": "controlPanel_preview",
        "cTitle": "Control Panel for Preview",
        "cType": "controlPanel",
        "cConfig": {
            "cId": "controlPanel_preview",
            "cTitle": "Control Panel for Preview",
            "cType": "controlPanel",
            "customTemplate": "<control name=\"TEST_MODE\"></control>",
            "controls": [
                {
                    "name": "TEST_MODE",
                    "type": "boolean",
                    "label": "Enable Test Mode",
                    "helpText": "Enabling test mode will allow you to change settings in this component, and test the save capability, without saving data to the server.",
                    "onchange": "layoutProperty.",
                    "onchangeArgs": [{ "arg": "testMode" }]
                }
            ]
        }
    },
    {
        "cId": "contactCard1",
        "cType": "contactCard",
        "cTitle": "Contact Card",
        "controls":
        [
            {
                "name": "CONTENT_DROPDOWN_FIELD",
                "type": "dropdownbutton"
            },
            {
                "name": "CONTENT_POPUP_FIELD",
                "type": "button",
                "onclick": "showContact"
            }
        ],
        "dataFormatter":
        [
            {
                "from": "contactCardData.VOL_FIRST_NAME",
                "to": "contactData.firstName"
            },
            {
                "from": "contactCardData.VOL_LAST_NAME",
                "to": "contactData.lastName"
            },
            {
                "from": "contactCardData.VOL_EMAIL",
                "to": "contactData.email"
            },
            {
                "from": "contactCardData.VOL_ATTACHMENT",
                "to": "contactData.avatar"
            },
            {
                "from": "contactCardData.VOL_MOBILE",
                "to": "contactData.phone[0].text"
            },
            {
                "from": "contactCardData.VOL_HOME",
                "to": "contactData.phone[1].text"
            },
            {
                "from": "contactCardData.VOL_ADDRESS",
                "to": "contactData.address[0].text"
            },
            {
                "from": "contactCardData.VOL_CITY",
                "to": "contactData.address[1].text"
            },
            {
                "from": "contactCardData.VOL_STATE",
                "to": "contactData.address[2].text"
            },
            {
                "from": "contactCardData.VOL_ZIPCODE",
                "to": "contactData.address[3].text"
            }
        ],
        "contentPosition": "header",
        "titleTemplate": "{{contactData.firstName}} {{contactData.lastName}}",
        "subTitleTemplate": "{{contactData.email}}",
        "contentFields": ["phone", "address"],
        "contentType": "dropdown",
        "avatarEnabled": true,
        "avatarType": "icon",
        "avatarUseDefault": true,
        "avatarSize": "e-avatar-xlarge",
        "avatarIsCircle": false
    },
    {
        "cId": "messagePanel_signin",
        "cType": "messagePanel",
        "cTitle": "Sign In Login Message",
        "cDescription": "",
        "headingTemplate": "",
        "customMessageTemplate": "",
        "allowDismiss": false,
        "messageFields": [],
        "mergeFields": [],
        "backdropType": "white void",
        "lockedConfig": true,
        "messagePanelMargin": "10px",
        "customMessagePanelMargin": "",
        "dismissStyle": "closeicon",
        "componentBackgroundColor": "#ffffffff",
        "componentBoxShadow": "0 0 15px rgba(0,0,0, 0.15)",
        "componentBorderRadius": "1",
        "backgroundColor": "#ffffffff",
        "borderColor": "#ffffffff",
        "textColor": "#000000ff"
    },
    {
        "cId": "messagePanel_signinVolunteerMessages",
        "cType": "messagePanel",
        "cTitle": "Sign In: Volunteer Messages",
        "cDescription": "",
        "headingTemplate": "",
        "customMessageTemplate": "",
        "allowDismiss": true,
        "messageFields": [],
        "mergeFields": [],
        "backdropType": "white void",
        "lockedConfig": true,
        "messagePanelMargin": "10px",
        "messagePanelPadding": "0",
        "messageItemPadding": "10px",
        "customMessagePanelMargin": "10px",
        "dismissStyle": "closeicon",
        "componentBackgroundColor": "#ffffffff",
        "componentBoxShadow": "0 0 15px rgba(0,0,0, 0.15)",
        "componentBorderRadius": "1",
        "backgroundColor": "#dff0d8ff",
        "borderColor": "#ffffffff",
        "textColor": "#3c763dff",
        "showAsToast": false,
        "toastInitialText": false,
        "useCommonComponentStyles": true,
        "commonComponentStyles": {
            "componentBorderRadius": null
        }
    },
    {
        "cId": "buildInfo_vms",
        "cType": "buildInfo",
        "hideFromDevDash": true,
        "cTitle": "VMS: Build info",
        "showSubbuild": true,
        "showDate": false,
        "showInstance": true
    },
    {
        "cId": "buildInfo_vms_about",
        "cType": "buildInfo",
        "hideFromDevDash": true,
        "cTitle": "VMS: Build info (About)",
        "showSubbuild": false,
        "showDate": false,
        "showInstance": false
    },
    {
        "cId": "loginForm_vms",
        "cType": "loginForm",
        "hideFromDevDash": true,
        "cTitle": "VMS: Login Form",
        "hideInstanceList": true,
        "showResetPwd": true,
        "inlineLabel": true
    },

    {
        "layoutId": "layoutContainer_VMS_Login",
        "hideFromDevDash": true,
        "components": [
            { "cId": "loginForm_vms", "cType": "loginForm" },
            { "cId": "buildInfo_vms", "cType": "buildInfo" },
            { "cId": "messagePanel_VMS_copyright", "cType": "messagePanel" },
            { "cId": "messagePanel_VMS_celebrationMessage", "cType": "messagePanel" },
            { "cId": "messagePanel_VMS_privacy", "cType": "messagePanel" }
        ],
        "positions": [
            {
                "label": "Header",
                "posIndex": 1,
                "components": []
            },
            {
                "label": "Main Column",
                "posIndex": 0,
                "components": [
                    { "cType": "messagePanel", "cId": "messagePanel_VMS_celebrationMessage", "position": 1 },
                    { "cType": "loginForm", "cId": "loginForm_vms", "position": 2 },
                    { "cType": "buildInfo", "cId": "buildInfo_vms", "position": 3 },
                    { "cType": "messagePanel", "cId": "messagePanel_VMS_copyright", "position": 4 },
                    { "cType": "messagePanel", "cId": "messagePanel_VMS_privacy", "position": 5 },
                ]
            },
            {
                "label": "Footer",
                "posIndex": 2,
                "components": []
            }
        ],
        "displayIf": [],
        "showIf": [],
        "description": "The main layout for VMS Login Page.",
        "settings": {
            "enableHeader": false,
            "header": "",
            "headerBgColor": "#ccccccff",
            "textColor": "#000000ff",
            "enableFooter": false,
            "columnRatio": "1:1",
            "layoutWidthType": "fluid",
            "bodyBgColor": "#ffffffff",
            "showComponentBorders": false
        },
        "storeProps": [],
        "templateFile": "staticTemplates/1_column.js",
        "layoutDatamap": [],
        "cType": "layoutContainer",
        "lockedConfig": true,
        "cId": "layoutContainer_VMS_Login",
        "cTitle": "VMS Login Page",
        "cDescription": "",
        "controls": [],
        "isGlobal": true
    },
    {
        "cId": "messagePanel_VMS_copyright",
        "cType": "messagePanel",
        "cTitle": "VMS: Copyright Message",
        "cDescription": "",
        "headingTemplate": "",
        "customMessageTemplate": "<span class=\"copyright\"><span><br>\n"
            + "          eCoordinator<sup class=\"tm\">TM</sup> is a product and service of Samaritan | Volunteer Management Software (VMS)<br>\n"
            + "    \t  Copyright © 2000 - 2022 Samaritan Technologies. All rights reserved world wide.\n"
            + "    \t</span></span>",
        "allowDismiss": false,
        "messageFields": [],
        "mergeFields": [],
        "backdropType": "white void",
        "lockedConfig": true,
        "messagePanelMargin": "0px",
        "customMessagePanelMargin": "",
        "dismissStyle": "closeicon",
        "componentBackgroundColor": "#ffffffff",
        "componentBoxShadow": "0 0 15px rgba(0,0,0, 0.15)",
        "componentBorderRadius": "1",
        "backgroundColor": "#ffffffff",
        "borderColor": "#ffffffff",
        "textColor": "#000000ff"
    },
    {
        "cId": "messagePanel_VMS_privacy",
        "cType": "messagePanel",
        "cTitle": "VMS: Privacy Message",
        "cDescription": "",
        "headingTemplate": "",
        "customMessageTemplate": "<div class='privacy-policy'>"
            + "<a href='https://samaritan.com/privacy-policy/' target='_blank'>Privacy Policy</a>"
            + "</div>",
        "allowDismiss": false,
        "messageFields": [],
        "mergeFields": [],
        "backdropType": "white void",
        "lockedConfig": true,
        "messagePanelMargin": "0px",
        "customMessagePanelMargin": "",
        "dismissStyle": "closeicon",
        "componentBackgroundColor": "#ffffffff",
        "componentBoxShadow": "0 0 15px rgba(0,0,0, 0.15)",
        "componentBorderRadius": "1",
        "backgroundColor": "#ffffffff",
        "borderColor": "#ffffffff",
        "textColor": "#000000ff"
    },
    {
        "cId": "messagePanel_VMS_login",
        "cType": "messagePanel",
        "cTitle": "VMS: Login Message",
        "cDescription": "",
        "headingTemplate": "",
        "customMessageTemplate": "<p id=\"loginMessage\">\n"
            + "        If you already have a User ID and password, please enter here:\n"
            + "    </p>",
        "allowDismiss": false,
        "messageFields": [],
        "mergeFields": [],
        "backdropType": "white void",
        "lockedConfig": true,
        "messagePanelMargin": "0px",
        "customMessagePanelMargin": "",
        "dismissStyle": "closeicon",
        "componentBackgroundColor": "#ffffffff",
        "componentBoxShadow": "0 0 15px rgba(0,0,0, 0.15)",
        "componentBorderRadius": "1",
        "backgroundColor": "#ffffffff",
        "borderColor": "#ffffffff",
        "textColor": "#000000ff"
    },
    {
        "cId": "messagePanel_VMS_celebrationMessage",
        "cType": "messagePanel",
        "cTitle": "VMS: Celebration Message",
        "cDescription": "",
        "headingTemplate": "",
        "customMessageTemplate": "<div id='celebrationMessage'><strong>\n"
            + "            In celebration of our 25th anniversary,<br>\n"
            + "            Samaritan is launching a new brand!  <a href=\"https://samaritan.com/rebrand/\" style=\"text-decoration: underline;\" target=\"_blank\">more...</a></strong></div>",
        "allowDismiss": false,
        "messageFields": [],
        "mergeFields": [],
        "backdropType": "white void",
        "lockedConfig": true,
        "messagePanelMargin": "0px",
        "customMessagePanelMargin": "",
        "dismissStyle": "closeicon",
        "componentBackgroundColor": "#ffffffff",
        "componentBoxShadow": "0 0 15px rgba(0,0,0, 0.15)",
        "componentBorderRadius": "1",
        "backgroundColor": "#ffffffff",
        "borderColor": "#ffffffff",
        "textColor": "#000000ff"
    },
    {
        "cId": "loginForm_ams",
        "cType": "loginForm",
        "hideFromDevDash": true,
        "cTitle": "AMS: Login Form",
        "hideInstanceList": true,
        "showResetPwd": false,
        "userType": "ams",
        "inlineLabel": false,
        "hideSkipLogin": true
    },
    {
        "cId": "messagePanel_AMS_privacy",
        "cType": "messagePanel",
        "cTitle": "AMS: Privacy Message",
        "cDescription": "",
        "headingTemplate": "",
        "customMessageTemplate": "<div class='privacy-policy'>"
            + "<a href='https://samaritan.com/privacy-policy/' target='_blank'>Samaritan's Privacy Policy</a>"
            + "</div>",
        "allowDismiss": false,
        "messageFields": [],
        "mergeFields": [],
        "backdropType": "white void",
        "lockedConfig": true,
        "messagePanelMargin": "0px",
        "customMessagePanelMargin": "",
        "dismissStyle": "closeicon",
        "componentBackgroundColor": "#ffffffff",
        "componentBoxShadow": "0 0 15px rgba(0,0,0, 0.15)",
        "componentBorderRadius": "1",
        "backgroundColor": "#ffffffff",
        "borderColor": "#ffffffff",
        "textColor": "#000000ff"
    },
    {
        "layoutId": "layoutContainer_AMS_Login",
        "hideFromDevDash": true,
        "components": [
            { "cId": "loginForm_ams", "cType": "loginForm" },
            { "cId": "messagePanel_AMS_privacy", "cType": "messagePanel" }
        ],
        "positions": [
            {
                "label": "Header",
                "posIndex": 1,
                "components": []
            },
            {
                "label": "Main Column",
                "posIndex": 0,
                "components": [
                    { "cType": "loginForm", "cId": "loginForm_ams", "position": 1 },
                    { "cType": "messagePanel", "cId": "messagePanel_AMS_privacy", "position": 2 },
                ]
            },
            {
                "label": "Footer",
                "posIndex": 2,
                "components": []
            }
        ],
        "displayIf": [],
        "showIf": [],
        "description": "The main layout for AMS Login Page.",
        "settings": {
            "enableHeader": false,
            "header": "",
            "headerBgColor": "#ccccccff",
            "textColor": "#000000ff",
            "enableFooter": false,
            "columnRatio": "1:1",
            "layoutWidthType": "fluid",
            "bodyBgColor": "#ffffffff",
            "showComponentBorders": false
        },
        "storeProps": [],
        "templateFile": "staticTemplates/1_column.js",
        "layoutDatamap": [],
        "cType": "layoutContainer",
        "lockedConfig": true,
        "cId": "layoutContainer_AMS_Login",
        "cTitle": "AMS Login Page",
        "cDescription": "",
        "controls": [],
        "isGlobal": true
    },
    {
        "cId": "loginForm_rms",
        "hideFromDevDash": true,
        "cType": "loginForm",
        "cTitle": "RMS: Login Form",
        "hideInstanceList": true,
        "showResetPwd": false,
        "userType": "rms",
        "inlineLabel": false,
        "hideSkipLogin": true
    },
    {
        "cId": "messagePanel_RMS_privacy",
        "cType": "messagePanel",
        "cTitle": "RMS: Privacy Message",
        "cDescription": "",
        "headingTemplate": "",
        "customMessageTemplate": "<div class='privacy-policy'>"
            + "<a href='https://samaritan.com/privacy-policy/' target='_blank'>Samaritan's Privacy Policy</a>"
            + "</div>",
        "allowDismiss": false,
        "messageFields": [],
        "mergeFields": [],
        "backdropType": "white void",
        "lockedConfig": true,
        "messagePanelMargin": "0px",
        "customMessagePanelMargin": "",
        "dismissStyle": "closeicon",
        "componentBackgroundColor": "#ffffffff",
        "componentBoxShadow": "0 0 15px rgba(0,0,0, 0.15)",
        "componentBorderRadius": "1",
        "backgroundColor": "#ffffffff",
        "borderColor": "#ffffffff",
        "textColor": "#000000ff"
    },
    {
        "layoutId": "layoutContainer_RMS_Login",
        "hideFromDevDash": true,
        "components": [
            { "cId": "loginForm_rms", "cType": "loginForm" },
            { "cId": "messagePanel_RMS_privacy", "cType": "messagePanel" }
        ],
        "positions": [
            {
                "label": "Header",
                "posIndex": 1,
                "components": []
            },
            {
                "label": "Main Column",
                "posIndex": 0,
                "components": [
                    { "cType": "loginForm", "cId": "loginForm_rms", "position": 1 },
                    { "cType": "messagePanel", "cId": "messagePanel_RMS_privacy", "position": 2 },
                ]
            },
            {
                "label": "Footer",
                "posIndex": 2,
                "components": []
            }
        ],
        "displayIf": [],
        "showIf": [],
        "description": "The main layout for RMS Login Page.",
        "settings": {
            "enableHeader": false,
            "header": "",
            "headerBgColor": "#ccccccff",
            "textColor": "#000000ff",
            "enableFooter": false,
            "columnRatio": "1:1",
            "layoutWidthType": "fluid",
            "bodyBgColor": "#ffffffff",
            "showComponentBorders": false
        },
        "storeProps": [],
        "templateFile": "staticTemplates/1_column.js",
        "layoutDatamap": [],
        "cType": "layoutContainer",
        "lockedConfig": true,
        "cId": "layoutContainer_RMS_Login",
        "cTitle": "RMS Login Page",
        "cDescription": "",
        "controls": [],
        "isGlobal": true
    },
];

export default baseComponentConfigs;
